import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Home from "./components/home/home";
import Store from "./components/store/store";
import About from "./components/About/about";
import ProductDescriptionPage from "./components/store/productDescriptionPage";
import Contact from "./components/contact/contact";
import Login from "./components/login/login";
import { CartProvider } from "./context/CartContext";
import Cart from "./components/cart/cart";
import SubmitOTP from "./components/login/submitOTP";
import Checkout from "./checkout/checkout";
import PrivacyPolicy from "./components/policy/PrivacyPolicy";
import Refund from "./components/policy/refund";
import TermsConditions from "./components/policy/termsConditions";
import ScrollToTop from "./scrolltotop.js";
import BuynowCheckout from "./checkout/buynowCheckout.js";
import Myorder from "./components/orders/myorder.js";
import Shipping from "./components/policy/shipping.js";
import Failed from "./paymentStstus/failed.js";
import Success from "./paymentStstus/success.js";
import DeletionPage from "./components/dataDeletionRequest/deletionPage.js"
function App() {
  return (
    <div className="App">
       <CartProvider>         
        <BrowserRouter>   
        <ScrollToTop />      
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/store" element={<Store />} />
              <Route path="/about" element={<About />} />
              <Route path="/product/:id" element={<ProductDescriptionPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/submit-otp" element={<SubmitOTP />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
              <Route path="/refund-policy" element={<Refund/>} />
              <Route path="/shipping-policy" element={<Shipping/>} />
              <Route path="/terms-conditions" element={<TermsConditions/>} />
              <Route path="/buynowcheckout" element={<BuynowCheckout/>} />
              <Route path="/myorders/:userId" element={<Myorder />} />
              <Route path="/failed" element={<Failed />} />
              <Route path="/success" element={<Success />} />
              <Route path="/deletion" element={<DeletionPage/>}/>
            </Routes>
          <ScrollToTop/> 
      </BrowserRouter>     
      </CartProvider>
       
    </div>
  );
}

export default App;
